import React from 'react'
import { formatMediaUrlForIframe } from './utils'

export interface YoutubeVideoProps {
  url: string
  title: string
  height?: string | number
  width?: string | number
}

export const YoutubeVideo = ({
  url,
  title,
  height = '100%',
  width = '100%',
}: YoutubeVideoProps) => (
  <iframe
    title={title}
    src={`${formatMediaUrlForIframe(url)}`}
    width={width}
    height={height}
    allow="autoplay; encrypted-media"
    allowFullScreen
    className="rounded-xl"
  />
)
